// グローバル state (virtual now の計算用)
// lastEventAt は最新受信イベントの at (ISO)。到着順揺らぎに耐えるため単調前進のみ。
// speed は「今動いている再生モード」の速度。virtual NOW は lastEventAt + 経過 * speed。

interface GlobalCounts {
  success: number;
  failure: number;
}

export const globalCounts: GlobalCounts = { success: 0, failure: 0 };

export const state = {
  lastEventAt: null as string | null,
  lastEventWallMs: null as number | null,
  engineSpeed: null as number | null,
};

export function currentSpeed(): number | null {
  return state.engineSpeed;
}

export function virtualNowMs(): number | null {
  if (state.lastEventAt === null) return null;
  const base = new Date(state.lastEventAt).getTime();
  if (Number.isNaN(base)) return null;
  const sp = currentSpeed();
  if (sp !== null && state.lastEventWallMs !== null) {
    return base + (Date.now() - state.lastEventWallMs) * sp;
  }
  return base;
}

export function noteIncomingEvent(at: string): void {
  const newAt = new Date(at).getTime();
  if (Number.isNaN(newAt)) return;
  const prev = state.lastEventAt === null ? -Infinity : new Date(state.lastEventAt).getTime();
  if (newAt >= prev) {
    state.lastEventAt = at;
    state.lastEventWallMs = Date.now();
  }
}

export function resetTimeState(): void {
  state.lastEventAt = null;
  state.lastEventWallMs = null;
}

export function resetGlobalCounts(): void {
  globalCounts.success = 0;
  globalCounts.failure = 0;
}
